import { FormReviewData } from "@/types";
import { formatFieldName } from "@/utils/formatters";

interface ConsultationRequirementsSectionProps {
  formData: FormReviewData;
}

export function ConsultationRequirementsSection({
  formData,
}: ConsultationRequirementsSectionProps) {
  const requirements = formData?.formData?.consultation_requirements;
  if (!requirements || Object.keys(requirements).length === 0) return null;

  const formatValue = (value: any): string => {
    if (value === "true" || value === true) return "Yes";
    if (value === "false" || value === false) return "No";
    if (value === "Not sure") return "Not Sure";
    return String(value);
  };

  const getValueColor = (value: any): string => {
    if (value === "true" || value === true) return "#10b981";
    if (value === "false" || value === false) return "#6b7280";
    if (value === "Not sure") return "#f59e0b";
    return "#1f2937";
  };

  return (
    <div className="info-card consultation-requirements">
      <h3>🩺 Consultation Requirements & Risk Factors</h3>
      <div
        className="requirements-grid"
        style={{ display: "flex", flexDirection: "column", gap: "16px" }}
      >
        {Object.entries(requirements).map(([key, value], index) => (
          <div
            key={key}
            className={`requirement-item grid grid-cols-1 sm:grid-cols-[200px_1fr] gap-4 items-start ${index < Object.keys(requirements).length - 1 ? "pb-3 border-b border-gray-200" : ""}`}
          >
            <label style={{ fontWeight: "700", color: "#374151" }}>
              {formatFieldName(key)}:
            </label>
            <span
              style={{
                color: getValueColor(value),
                fontWeight: "500",
              }}
            >
              {formatValue(value)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
